import { useQuery } from 'react-query';
import { cacheKeys } from './cacheKeys';
import { handleRequest } from '../../redux/services/APIService';

export const useGetInquiryMessages = (
  options = { inquiryId: '' },
) => {
  return useQuery(
    cacheKeys.getInquiryMessages(options),
    async () => {
      if (!options?.inquiryId) return [];

      const response = await handleRequest(
        'get',
        `contact-requests/${options.inquiryId}/messages`,
        true,
        null,
        options.filter,
      );

      return response.data;
    },
    {
      onError: (error) => {
        console.error(
          `${error.response?.data?.data?.resultMessage || error.message}`,
        );
      },
      ...options,
    },
  );
};
